import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=410f8876&scoped=true&"
import script from "./Password.vue?vue&type=script&lang=tsx&"
export * from "./Password.vue?vue&type=script&lang=tsx&"
import style0 from "./Password.vue?vue&type=style&index=0&id=410f8876&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410f8876",
  null
  
)

export default component.exports